var styles = {"text":"MinValue_text_zjn6k_1","image":"MinValue_image_zjn6k_21"};

export { styles as default };
//# sourceMappingURL=index.module.scss.js.map
